import { useState, useEffect } from 'react'
import FormModal from '../FormModal'

const formStyles = {
  field: {
    marginBottom: '0.4rem',
  },
  label: {
    display: 'block',
    color: 'var(--text-primary)',
    marginBottom: '0.4rem',
    fontSize: '0.95rem',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    background: 'var(--accent-deep)',
    border: '1px solid var(--accent-teal)',
    borderRadius: '6px',
    color: 'var(--text-primary)',
    fontSize: '0.95rem',
    fontFamily: 'inherit',
  },
  textarea: {
    width: '100%',
    padding: '0.75rem',
    background: 'var(--accent-deep)',
    border: '1px solid var(--accent-teal)',
    borderRadius: '6px',
    color: 'var(--text-primary)',
    fontSize: '0.95rem',
    fontFamily: 'inherit',
    minHeight: 'clamp(140px, 22vh, 380px)',
    resize: 'vertical',
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  checkboxInput: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
}

function SecretForm({ isOpen, onClose, secret = null, onSubmit }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    benefits: '',
    drawbacks: '',
    is_mystery: 0,
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Update form data when secret prop changes
  useEffect(() => {
    if (secret) {
      setFormData({
        name: secret.name || '',
        description: secret.description || '',
        benefits: secret.benefits || '',
        drawbacks: secret.drawbacks || '',
        is_mystery: secret.is_mystery || 0,
      })
    } else {
      setFormData({
        name: '',
        description: '',
        benefits: '',
        drawbacks: '',
        is_mystery: 0,
      })
    }
  }, [secret])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      await onSubmit(formData)
      onClose()
    } catch (error) {
      console.error('Form submission error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={secret ? 'Edit Secret' : 'Create New Secret'}
      isSubmitting={isSubmitting}
    >
      <div style={formStyles.field}>
        <label style={formStyles.label} htmlFor="name">Name *</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          style={formStyles.input}
          placeholder="e.g., Harper Agent, ???"
        />
      </div>

      <div style={formStyles.field}>
        <label style={formStyles.label} htmlFor="description">Description *</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
          style={formStyles.textarea}
          placeholder="What is this secret or power?"
        />
      </div>

      <div style={formStyles.field}>
        <label style={formStyles.label} htmlFor="benefits">Benefits</label>
        <textarea
          id="benefits"
          name="benefits"
          value={formData.benefits}
          onChange={handleChange}
          style={formStyles.textarea}
          placeholder="What advantages does this secret provide?"
        />
      </div>

      <div style={formStyles.field}>
        <label style={formStyles.label} htmlFor="drawbacks">Drawbacks</label>
        <textarea
          id="drawbacks"
          name="drawbacks"
          value={formData.drawbacks}
          onChange={handleChange}
          style={formStyles.textarea}
          placeholder="What are the risks or negative consequences?"
        />
      </div>

    </FormModal>
  )
}

export default SecretForm
